var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./MemberProfile.jinja');
require('./MemberProfile.less');

var MemberProfileInfo = require('front/components/MemberProfile/MemberProfileInfo');
var MemberProfileSettings = require('front/components/MemberProfile/MemberProfileSettings');
var MemberProfileBio = require('front/components/MemberProfile/MemberProfileBio');
var MemberProfileDomicile = require('front/components/MemberProfile/MemberProfileDomicile');
var MemberProfileSkills = require('front/components/MemberProfile/MemberProfileSkills');
var MemberProfileExperience = require('front/components/MemberProfile/MemberProfileExperience');
var MemberProfileRecognition = require('front/components/MemberProfile/MemberProfileRecognition');
var MemberProfileLocation = require('front/components/MemberProfile/MemberProfileLocation');
var MemberProfileCredits = require('front/components/MemberProfile/MemberProfileCredits');
var MemberProfilePortfolio = require('front/components/MemberProfile/MemberProfilePortfolio');

var MemberProfileEdit = require('front/components/MemberProfileEdit/MemberProfileEdit');
var MemberProfileEditRuntime = require('front/components/MemberProfileEdit/MemberProfileEditRuntime.jinja');

module.exports = Base.extend({

    template: template,

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'MemberProfileInfo': {selector: '.MemberProfileInfo', viewConstructor: MemberProfileInfo},
        'MemberProfileSettings': {selector: '.MemberProfileSettings', viewConstructor: MemberProfileSettings},
        'MemberProfileBio': {selector: '.MemberProfileBio', viewConstructor: MemberProfileBio},
        'MemberProfileDomicile': {selector: '.MemberProfileDomicile', viewConstructor: MemberProfileDomicile},
        'MemberProfileSkills': {selector: '.MemberProfileSkills', viewConstructor: MemberProfileSkills},
        'MemberProfileExperience': {selector: '.MemberProfileExperience', viewConstructor: MemberProfileExperience},
        'MemberProfileRecognition': {selector: '.MemberProfileRecognition', viewConstructor: MemberProfileRecognition},
        'MemberProfileLocation': {selector: '.MemberProfileLocation', viewConstructor: MemberProfileLocation},
        'MemberProfileCredits': {selector: '.MemberProfileCredits', viewConstructor: MemberProfileCredits},
        'MemberProfilePortfolio': {selector: '.MemberProfilePortfolio', viewConstructor: MemberProfilePortfolio}
    },

    saveApi: function () {
        return Urls['member:api:member'](this.memberId, 'json');
    },


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'openEditPopup', 'closeEditPopup', 'hiddenBlock', 'saveApi');

        this.memberId = this.options.memberId;

        this.editSections = [];

        this.editSections.info = '.MemberProfileInfoInner';
        this.editSections.settings = '.MemberProfileSettingsInner';
        this.editSections.password = '.MemberProfileSettingsInner';
        this.editSections.passwordForgot = '.MemberProfileSettingsInner';
        this.editSections.bio = '.MemberProfileBioInner';
        this.editSections.domicile = '.MemberProfileDomicileInner';
        this.editSections.skills = '.MemberProfileSkillsInner';
        this.editSections.experience = '.MemberProfileExperienceInner';
        this.editSections.recognition = '.MemberProfileRecognitionInner';
        this.editSections.location = '.MemberProfileLocationInner';
        this.editSections.credits = '.MemberProfileCreditsInner';
        this.editSections.creditsAdd = '.MemberProfileCreditsInner';
        this.editSections.creditsEdit = '.MemberProfileCreditsInner';
        this.editSections.portfolio = '.MemberProfilePortfolioInner';

        window.app.vent.on('MemberProfileEdit--open', this.openEditPopup);
        window.app.vent.on('MemberProfileEdit--close', this.closeEditPopup);
        window.app.vent.on('MemberProfileEdit--hidden', this.hiddenBlock);

        this.$editPopupContentItem = $('<div class="EditPopupContent-item"></div>').insertAfter(this.$el.closest('.BasePopup'));
        this.$editPopupContent = $('<div class="EditPopupContent"></div>').insertAfter(this.$el.closest('.BasePopup'));

        Base.prototype.initialize.call(this, options);
    },


    deactivate: function (params) {
        window.app.vent.off('MemberProfileEdit--open', this.openEditPopup);
        window.app.vent.off('MemberProfileEdit--close', this.closeEditPopup);
        window.app.vent.off('MemberProfileEdit--hidden', this.hiddenBlock);

        this.$editPopupContent.remove();
        this.$editPopupContentItem.remove();

        return Base.prototype.deactivate.call(this, params);
    },


    openEditPopup: function (block, visibility, item, noTransition) {
        var self = this;

        if (!noTransition) {
            noTransition = false;
        }

        if (block == 'private') {
            this.block = 'settings';
        } else {
            this.block = block;
        }

        if (!visibility) {
            visibility = false;
        }

        var $popupContainer = (this.block == 'creditsAdd' || this.block == 'creditsEdit' || this.block == 'passwordForgot') ? this.$editPopupContentItem : this.$editPopupContent;

        if (this.block == 'settings') {
            var $template = $(MemberProfileEditRuntime.render({
                data: window.app.data.members[this.memberId],
                dictionaries: window.app.data.memberDictionaries,
                component: this.block,
                visibility: visibility,
                item: item || {}
            }));

            $popupContainer.html($template);

            this.MemberProfileEdit = new MemberProfileEdit({
                el: $popupContainer.find('.MemberProfileEdit')[0],
                block: this.block,
                visibility: visibility,
                memberId: this.memberId
            });

            $popupContainer
                .find('.MemberProfileEdit')
                .outerHeight();
            $popupContainer
                .find('.MemberProfileEdit')
                .removeClass('hidden');
        } else {
            var $template = $(MemberProfileEditRuntime.render({
                data: window.app.data.members[self.memberId],
                dictionaries: window.app.data.memberDictionaries,
                component: self.block,
                visibility: visibility,
                item: item || {}
            }));

            $popupContainer.html($template);

            if (self.block == 'creditsAdd' || self.block == 'creditsEdit' || self.block == 'passwordForgot') {
                self.MemberProfileEditCredit = new MemberProfileEdit({
                    el: $popupContainer.find('.MemberProfileEdit')[0],
                    block: self.block,
                    visibility: visibility,
                    memberId: self.memberId,
                    item: item
                });
            } else {
                self.MemberProfileEdit = new MemberProfileEdit({
                    el: $popupContainer.find('.MemberProfileEdit')[0],
                    block: self.block,
                    visibility: visibility,
                    memberId: self.memberId
                });
            }

            if (!noTransition) {
                $popupContainer
                    .find('.MemberProfileEdit')
                    .outerHeight();
                $popupContainer
                    .find('.MemberProfileEdit')
                    .removeClass('hidden');
            } else {
                $popupContainer
                    .find('.MemberProfileEdit')
                    .addClass('noTransition');
                $popupContainer
                    .find('.MemberProfileEdit')
                    .outerHeight();
                $popupContainer
                    .find('.MemberProfileEdit')
                    .removeClass('hidden noTransition');
            }
        }
    },


    closeEditPopup: function (block, noTransition) {
        var delay = 350;

        if (block == 'private') {
            this.block = 'settings';
        } else {
            this.block = block;
        }

        var $popupContainer = (this.block == 'creditsAdd' || this.block == 'creditsEdit' || this.block == 'passwordForgot') ? this.$editPopupContentItem : this.$editPopupContent;

        if (noTransition) {
            delay = 0;
            $popupContainer
                .find('.MemberProfileEdit')
                .addClass('noTransition');
        } else {
            $popupContainer
                .find('.MemberProfileEdit')
                .addClass('hidden');

        }

        setTimeout(function () {
            $popupContainer.html('');

            if (this.block == 'creditsAdd' || this.block == 'creditsEdit' || this.block == 'passwordForgot') {
                this.MemberProfileEditCredit.deactivate();
                delete this.MemberProfileEditCredit;
            } else {
                this.MemberProfileEdit.deactivate();
                delete this.MemberProfileEdit;
            }
        }.bind(this), delay);
    },


    hiddenBlock: function (block, isHidden) {
        if (block == 'private') {
            this.block = 'settings';
        } else {
            this.block = block;
        }

        this.$(this.editSections[this.block]).toggleClass('hidden', isHidden);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfile/MemberProfile.js
// module id = 187
// module chunks = 0